/** Title-case values sent to API as `p_document_type`. */
export const RESOURCE_DOCUMENT_TYPES = {
  BROCHURE: 'Brochure',
  WHITE_PAPER: 'White Paper',
  EXECUTIVE_SUMMARY: 'Executive Summary',
} as const;

export type ResourceDocumentType =
  (typeof RESOURCE_DOCUMENT_TYPES)[keyof typeof RESOURCE_DOCUMENT_TYPES];
